import { customersApi, locationsManagementApi } from '@/api';
import { LAB_SAMPLE_STATUSES } from '../constants';

const receivedSamplesFilters = [
  {
    name: 'customerId',
    label: 'customerIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const customersResponse = await customersApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = customersResponse.data.map((c) => ({
        label: `${c.id} ${c.name}`,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'labSampleCode',
    label: 'sampleId',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'orderSentAt',
    label: 'orderDate',
    type: 'dateDay',
    // whereOperator: 'regexp',
  },
  {
    name: 'lastModifiedAt',
    label: 'timestampChange',
    type: 'dateDay',
  },
  {
    name: 'productCode',
    label: 'productCode',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'productName',
    label: 'productName',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'locationId',
    label: 'locationIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const locationsResponse = await locationsManagementApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = locationsResponse.data.map((c) => ({
        label: c.name,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'orderId',
    label: 'orderId',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'lot',
    label: 'batch',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'status',
    label: 'toBeAcceptedRefused',
    type: 'select',
    whereOperator: '=',
    options: [
      { label: 'filters.toBeAccepted', value: LAB_SAMPLE_STATUSES.PENDING },
      { label: 'filters.refused', value: LAB_SAMPLE_STATUSES.REJECTED },
    ],
  },
];

export default receivedSamplesFilters;
